import BaseModel from './BaseModel';

class InspectionItem extends BaseModel {
  constructor(data = {}, key) {
    super(data);
    this.updateData(data);
  }

  updateData = (data) => {
    this.id = data.id
    this.name = data.name || ""
    this.amount = data.amount || 0
    this.is_active = data.is_active === true ? true : data.is_active === false ? false : true
    this.chargable = data.chargable === true ? true : data.chargable === false ? false : true
    this.gst = data.gst || 0
    this.index = data.index
  }

  // toApiJson = () => {
  //   this.completeValidation();
  //   return {
  //     inspection_items: this.inspection_items,
  //   }
  // }

  validations = (field) => {
    return {
      name: () => {
        if (this[field] === "") {
          this.errors.name = "Please enter name";
        } else{
          delete this.errors.name;
        }
      },
      amount: () => {
        if (this[field] === "") {
          this.errors.amount = "Please enter amount";
        } else{
          delete this.errors.amount;
        }
      },
      gst: () => {
        if (this[field] >= 100 || this[field] < 0) {
          this.errors.gst = "Please enter valid gst amount";
        } else{
          delete this.errors.gst;
        }
      },
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default InspectionItem;
